<template>
  <v-select
    v-bind="$attrs"
    v-model="selected"
    :items="groups"
    :label="label"
    multiple
    item-text="name"
    item-value="code"
  >
    <template slot="append-outer">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">info</v-icon>
        </template>
        <span v-html="$t('When group is being selected, this product will become available only for it <br> becoming automatically unavailable for other customer groups. <br> When no group is selected, then product is available for all.')" />
      </v-tooltip>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'CustomerGroupSelect',

  props: {
    value: {
      type: [Array, null],
      default: null
    }
  },

  data () {
    return {
      groups: []
    }
  },

  computed: {
    selected: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    label () {
      let suffix = ''
      if (this.value === null ||
        (Array.isArray(this.value) && this.value.length === 0)) {
        suffix = ` (${this.$t('all')})`
      }

      return `${this.$t('Allowed Groups')}` + suffix
    }
  },

  async created () {
    this.groups = await this.$http.make('customer:group').get()
  }
}
</script>
